import Text from "./Text";

const Impressum = () => {
    return (
        <div className="h-full overflow-y-auto p-6 flex flex-col gap-4">
            <Text type="main">Impressum</Text>

            <Text type="title">Anbieter</Text>
            <Text>
                Cashier One
            </Text>

            <Text type="title">Betreiber</Text>
            <Text>
                Oliver Hollenbach
            </Text>

            <Text type="title">Adresse</Text>
            <Text>
                Oberstieg 31<br />
                8222 Beringen<br />
                Schweiz
            </Text>

            <Text type="title">Kontakt</Text>
            <a
                href="mailto:raycraftstudios.ch@gmail.com"
                className="hover:underline"
            >
                <Text classNames={"hover:underline"}>raycraftstudios.ch@gmail.com</Text>
            </a>

            <Text type="title">Haftungsausschluss</Text>
            <Text>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
                Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
                deren Betreiber verantwortlich.
            </Text>

            <Text type="title">Urheberrecht</Text>
            <Text>
                Die Inhalte und Werke auf dieser Plattform unterliegen dem schweizerischen
                Urheberrecht. Die Vervielfältigung, Bearbeitung oder Verbreitung bedarf der
                vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.
            </Text>

            <Text type="title">Anwendbares Recht</Text>
            <Text>
                Es gilt schweizerisches Recht.
            </Text>
        </div>
    );
}
export default Impressum